import { gsap } from "gsap";
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Utils } from "../misc/Utils";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export class ProjectPageHandler extends PageHandler {
	constructor(id) {
		super(id);
	}

	ajax() {

	}

	events() {
		
		let mm = gsap.matchMedia();
		mm.add("(min-width: 769px)", function() {
			var section = document.querySelector('.section__description--reversed .section__description-right')
			var img = document.querySelector('.section__description--reversed .section__description-left .img-container')
			ScrollTrigger.create({
				trigger: img,
				start: 'top top+=120px',
				end: () => `bottom ${120 + jQuery(img).height()}px`,
				endTrigger: section,
				pin: true,
				pinSpacing: false,
				invalidateOnRefresh: true
			})

			var section2 = document.querySelector('.section__description:nth-child(4) .section__description-left')
			var img2 = document.querySelector('.section__description:nth-child(4) .section__description-right .img-container')
			ScrollTrigger.create({
				trigger: img2,
				start: 'top top+=120px',
				end: () => `bottom ${120 + jQuery(img2).height()}px`,
				endTrigger: section2,
				pin: true,
				pinSpacing: false,
				invalidateOnRefresh: true
			})
		});
	}

	transitions() {
		
	}

	init() {
		this.events();
	}

	destroy() {

	}
}
